import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        registration: {
          module: () => import('../../../registration/registration.module').then((m) => m.RegistrationModule),
          cmsComponents: ['B2bRegistrationComponent', 'B2iRegistrationComponent', 'CompanySelectionComponent'],
        },
      },
    } as CmsConfig),
  ],
})
export class RegistrationFeatureModule {}
